<template>
    <div>
        <q-modal v-model="show_duplicate_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '40vh'}" @hide="hideDuplicate()">
            <q-modal-layout>
                <q-toolbar slot="header">
                <q-btn flat round dense @click="hideDuplicate()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('duplicate_this_training') }}
                    </q-toolbar-title>
                </q-toolbar>
                <div class="q-pa-md col-xs-12 col-sm-12">
                    <h6 class="text-h6 q-my-md">{{ $t('duplicate_this_training') }}</h6>
                    <div class="text-body1 q-mb-md">{{ $t('training_duplication_information') }}</div>

                    <div class="row">
                        <q-list class="col-12" bordered separator>
                            <q-item>
                                <q-item-main :label="$t('basic_data')" />
                            </q-item>
                            <q-item>
                                <q-item-main :label="$t('events_duplication_info')" />
                            </q-item>
                            <q-item>
                                <q-item-main :label="$t('reaction_tests')" />
                            </q-item>
                            <q-item>
                                <q-item-main :label="$t('support_materials')" />
                            </q-item>
                            <q-item>
                                <q-item-main :label="$t('inputs')" />
                            </q-item>
                        </q-list>
                    </div>

                    <p class="q-ml-sm q-mt-md text-weight-bold">{{ $t('training_duplication_save_warning') }}</p>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-4" >
                            <q-btn color="tertiary" class="full-width" :label="$t('close')" icon="fas fa-times" @click="hideDuplicate()" />
                        </div>
                        <div class="col-xs-12 col-sm-4" >
                            <q-btn color="primary" class="full-width" :label="$t('duplicate')" icon="far fa-copy" @click="duplicateTraining" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AdminPresentialDuplicate',

    props: ['show'],

    data() {
        return {
            id: '',
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
		}),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_duplicate_modal: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('hideDuplicate')
            }
        },
    },

    methods: {
        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '85vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '80vw'
        },

        hideDuplicate() {
            this.$emit('hideDuplicate')
        },

        duplicateTraining() {
            this.$q.loading.show()
            this.$axios.get(`/presential/presential_events/${this.id}/duplicate/`, this.getHeader)
            .then(response => {
                this.$router.push({ name: 'appointment', params: { id: response.data.presential_event_duplicated_id } })

                this.$emit('hideDuplicate')

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                this.$q.notify({
                        message: this.$t('duplicate_training_error'),
                        type: 'negative',
                        icon: 'fas fa-sign-in-alt'
                    })
                console.log(e)
            })
        },
    },

    mounted () {
        this.id = this.$route.params.id
    },

}
</script>

<style>

</style>
